"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var formik_1 = require("formik");
var React = tslib_1.__importStar(require("react"));
var __1 = require("../");
var InfoIcon_1 = tslib_1.__importDefault(require("../../icons/InfoIcon"));
var CustomerAuth_validations_1 = require("./CustomerAuth.validations");
/** @component */
exports.CustomerAuth = function (props) {
    var _a;
    var formikProps = props.formikProps, onValidationChange = props.onValidationChange, children = props.children, accountTooltipMsg = props.accountTooltipMsg, validationConfig = props.validationConfig, subFormConfig = props.subFormConfig, valuesKey = props.valuesKey, accountType = props.accountType;
    var accountNumberValidator = accountType === 'customer'
        ? CustomerAuth_validations_1.accountNumberValidation
        : accountType === 'accountCore'
            ? CustomerAuth_validations_1.accountNumberCoreValidation
            : CustomerAuth_validations_1.fuelAccountNumberValidation;
    /** Provide default validation config if none supplied */
    var customerAuthValidationConfig = validationConfig
        ? validationConfig
        : (_a = {},
            _a[valuesKey] = {
                accountNumber: accountNumberValidator,
                firstName: CustomerAuth_validations_1.nameValidation,
                lastName: CustomerAuth_validations_1.nameValidation,
                dob: CustomerAuth_validations_1.dateValidation
            },
            _a);
    var values = formikProps.values;
    var config = subFormConfig(values, customerAuthValidationConfig);
    return (React.createElement(__1.SubForm, { formikProps: formikProps, config: config, onValidationChange: onValidationChange, valuesKey: valuesKey }, function (subFormChildRenderProps) { return (React.createElement(React.Fragment, null,
        React.createElement(__1.FlexGrid, null,
            React.createElement(__1.FlexGridItem, { sm: 6, xs: 12, margin: { bottom: 'small' } },
                React.createElement(formik_1.FastField, { name: valuesKey + ".accountNumber", id: valuesKey + ".accountNumber", "data-testid": "customerAuth_accountNumber", ariaRequired: true, type: "tel", label: accountType && accountType === 'fuel'
                        ? 'Electricity or Gas reference number'
                        : accountType && accountType === 'accountCore'
                            ? 'Electricity or gas account / reference number'
                            : 'Customer reference number', maxLength: accountType === 'accountCore' ? 9 : undefined, placeholder: accountType === 'fuel'
                        ? 'Electricity or Gas reference number'
                        : accountType === 'accountCore'
                            ? 'Electricity or gas account / reference number'
                            : 'Customer reference number', component: __1.FormMaskedTextInput, options: {
                        numeral: true,
                        stripLeadingZeroes: false,
                        numeralThousandsGroupStyle: 'none',
                        numeralDecimalMark: 'none',
                        numeralPositiveOnly: true
                    }, icon: React.createElement(__1.Tooltip, { content: React.createElement(__1.Text, null, accountTooltipMsg), openOnClick: true, openOnFocus: true, openOnHover: true, ariaLabel: "Customer reference number", maxWidth: 300 },
                        React.createElement(InfoIcon_1.default, null)) })),
            React.createElement(__1.FlexGridItem, { sm: 6, xs: 12, margin: { bottom: 'small' } },
                React.createElement(formik_1.FastField, { name: valuesKey + ".firstName", id: valuesKey + ".firstName", "data-testid": "customerAuth_firstName", type: "text", label: "First name", placeholder: "First name", ariaRequired: true, component: __1.FormTextInput })),
            React.createElement(__1.FlexGridItem, { sm: 6, xs: 12, margin: { bottom: 'small' } },
                React.createElement(formik_1.FastField, { name: valuesKey + ".lastName", id: valuesKey + ".lastName", "data-testid": "customerAuth_lastName", type: "text", label: "Last name", placeholder: "Last name", ariaRequired: true, component: __1.FormTextInput })),
            React.createElement(__1.FlexGridItem, { sm: 6, xs: 12, margin: { bottom: 'small' } },
                React.createElement(formik_1.FastField, { name: valuesKey + ".dob", id: valuesKey + ".dob", "data-testid": "customerAuth_dob", type: "tel", label: "Date of birth", ariaRequired: true, component: __1.FormMaskedTextInput, options: {
                        date: true,
                        datePattern: ['d', 'm', 'Y']
                    }, placeholder: "DD/MM/YYYY" }))),
        children(subFormChildRenderProps))); }));
};
//# sourceMappingURL=CustomerAuth.js.map